<script>
import ENUMS from '@shared/messages/enums.json';

export default {
  messages: {
    statusClass: ENUMS.membershipStatusClass,
  },
  data() {
    return {
      isFetching: false,
    };
  },
  computed: {
    memberships() {
      return this.$store.state.memberships.list?.data || [];
    },
  },
  methods: {
    getData() {
      this.isFetching = true;
      this.$store.dispatch('memberships/fetch')
        .finally(() => {
          this.isFetching = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<!--<template>
  <form @submit.prevent="!isFetching && getData()">
    <b-skeleton v-if="isFetching" height="400" />
    <template v-else>
      <ul v-if="memberships.length > 0">
        <li
          v-for="membership in memberships"
          :key="membership.uuid"
          class="box flex-between-center"
        >
          <div>
            <p>
              <b-icon icon="calendar-check" class="mr-2" />
              Abonnement : <b>{{ membership.name }}</b>
              <br>
              <span class="tag mt-2">
                <b-icon
                  class="mr-1 is-size-9"
                  icon="circle"
                  :type="$options.messages.statusClass[membership.status]"
                />
                <span v-t="`memberships.status.${membership.status}`" />
              </span>
            </p>
          </div>
          <b-button class="ml-5" @click="$emit('choose', membership)">
            Sélectionner
          </b-button>
        </li>
      </ul>
      <p v-else class="notification">
        Aucun abonnement.
      </p>
    </template>
  </form>
</template>-->
